import { render } from "./AutoCompleteCollaborators.vue?vue&type=template&id=44f6ff8e&ts=true"
import script from "./AutoCompleteCollaborators.vue?vue&type=script&lang=ts"
export * from "./AutoCompleteCollaborators.vue?vue&type=script&lang=ts"

import "./AutoCompleteCollaborators.vue?vue&type=style&index=0&id=44f6ff8e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__